export interface OverallPremiumState {
    overallPremiumBit: PremiumStatusEnum;
    accountsLoadPending: boolean;
}
export type { OverallPremiumState as default };

export enum PremiumStatusEnum {
    Premium = 2,
    NonPremium = 1,
    Unset = -1
}
